import type { FC, ReactNode } from 'react'
import type { LucideProps } from 'lucide-react'
import type { ServiceIcon as ServiceIconName } from '@/content/types'

import {
    Building2,
    Calculator,
    Compass,
    Globe,
    Landmark,
    Sparkles,
    TrendingUp,
    Users
} from 'lucide-react'

interface ServiceIconProps extends LucideProps {
    name: ServiceIconName
}

const icons = {
    'landmark': Landmark,
    'calculator': Calculator,
    'users': Users,
    'compass': Compass,
    'sparkles': Sparkles,
    'globe': Globe,
    'line-chart': TrendingUp,
    'building': Building2
}

export const ServiceIcon: FC<ServiceIconProps> = ({ name, ...props }): ReactNode => {
    const Icon = icons[name] ?? Sparkles
    return <Icon aria-hidden='true' {...props} />
}
